var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInevntryIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.5701L11.5963 15.6663L12.65 14.6123L15.5 17.4623L21.1693 11.7931L22.223 12.8471L15.5 19.5701ZM20.5 10.0008H19V5.30859C19 5.23159 18.9679 5.16109 18.9038 5.09709C18.8398 5.03293 18.7692 5.00084 18.6923 5.00084H16.5V7.61609H7.5V5.00084H5.30775C5.23075 5.00084 5.16025 5.03293 5.09625 5.09709C5.03208 5.16109 5 5.23159 5 5.30859V18.6931C5 18.7701 5.03208 18.8406 5.09625 18.9046C5.16025 18.9688 5.23075 19.0008 5.30775 19.0008H11V20.5008H5.30775C4.80908 20.5008 4.38308 20.3243 4.02975 19.9711C3.67658 19.6178 3.5 19.1918 3.5 18.6931V5.30859C3.5 4.80993 3.67658 4.38393 4.02975 4.03059C4.38308 3.67743 4.80908 3.50084 5.30775 3.50084H9.7135C9.852 3.01368 10.135 2.60984 10.5625 2.28934C10.99 1.96884 11.4692 1.80859 12 1.80859C12.5513 1.80859 13.0382 1.96884 13.4605 2.28934C13.883 2.60984 14.1635 3.01368 14.302 3.50084H18.6923C19.1909 3.50084 19.6169 3.67743 19.9703 4.03059C20.3234 4.38393 20.5 4.80993 20.5 5.30859V10.0008ZM12 5.11634C12.2577 5.11634 12.4728 5.03009 12.6453 4.85759C12.8176 4.68509 12.9038 4.47001 12.9038 4.21234C12.9038 3.95468 12.8176 3.73959 12.6453 3.56709C12.4728 3.39476 12.2577 3.30859 12 3.30859C11.7423 3.30859 11.5273 3.39476 11.3548 3.56709C11.1824 3.73959 11.0963 3.95468 11.0963 4.21234C11.0963 4.47001 11.1824 4.68509 11.3548 4.85759C11.5273 5.03009 11.7423 5.11634 12 5.11634Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInevntryIcn);
export default __webpack_public_path__ + "static/media/inevntryIcn.993dcf2c1651bb1b8e378a6955890f39.svg";
export { ForwardRef as ReactComponent };